import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import bemify, { toModifiers } from 'bemify-js';
// Builds a simple component that renders a `div` within
// `children` in it, automatically applying `className`
// and any `kind` modifiers to the `div`.

type CommonComponentProps = {
  className?: string;
  children?: React.ReactNode;
  kind?: Array<string> | string;
  tag?: string;
  tagKind?: string;
  [s: string]: any;
};

const buildCommonComponent = (block: string) => {
  const bem = bemify(block);
  return (
    element?: string | null,
    defaultTag: string | React.ComponentType<any> = 'div'
  ) => {
    const Component = ({
      className,
      children,
      kind,
      tag,
      ...props
    }: CommonComponentProps) =>
      React.createElement(
        tag || defaultTag,
        {
          ..._.omit(props, 'tagKind'),
          kind: props.tagKind,
          className: bem(element, toModifiers(kind), className),
        },
        children
      );

    Component.propTypes = {
      tag: PropTypes.string,
      tagKind: PropTypes.string,
    };
    Component.displayName = `buildCommonComponent(${block}${element || ''})`;
    return Component;
  };
};

export default buildCommonComponent;
